import React, { useState } from "react";
import UnauthorizedTheme from './unauthorized.styles';
import { useCookies } from 'react-cookie';


const Unauthorized = (props) => {

    const classes = UnauthorizedTheme();

    const [cookies] = useCookies(['errorName']);
    const [showing, setShowing] = useState(false);

    const back = () => {
        if (typeof window !== 'undefined'){
            window.location.href = '/';
        }
    }

    return(
        <div className={classes.Container}>
            <div className={classes.Content}>
                <h1 className={classes.Title}>403!</h1>
                <p className={classes.Text}>Infelizmente não foi possível liberar seu acesso.</p>
                <div className={classes.ErrorContent}>
                    <button className={classes.ButtonLink} onClick={() => setShowing(!showing)}>Detalhes</button>
                    { showing 
                        ? <div className={classes.ErrorDetail}>
                            <p>{cookies.errorName}!</p>
                            <p>{cookies.errorMessage}</p>
                        </div>
                        : null
                    }
                </div>
                <div className={classes.Button} onClick={() => back()}>Voltar</div>
            </div>
        </div>
    );
}

export default Unauthorized;